"use client";

import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useQueryParam(name: string) {
  const [searchParams] = useSearchParams();
  return useMemo(() => searchParams.get(name) || "", [name, searchParams]);
}
